import React, { useState } from 'react';
import { Modal, Box, TextField, Button, Typography } from '@mui/material';
import emailjs from '@emailjs/browser';
import { forgotPassword } from '../../utils/api'; // Adjust the path to where getUserById is located

const ForgotPassword = ({ open, onClose }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (!email) {
            setMessage('Please enter your email.');
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            // Step 1: Request the backend to reset the password
            const response = await forgotPassword(email);

            // Step 2: Validate the response
            if (!response.email) {
                throw new Error('User email not found in response. Please ensure the email is correct.');
            }

            // Step 3: Send the password reset email using EmailJS
            const templateParams = {
                username: response.username,
                newPassword: response.newPassword,
                to_email: response.email,
                email: response.email, // For the {{email}} placeholder in the template
            };

            await emailjs.send(
                'service_46bv0oq', // Same Service ID as TrainerHunt
                'template_wyhob5e', // Your EmailJS Template ID for password reset
                templateParams,
                'yH0mz21D4OHFGHtEf' // Same User ID as TrainerHunt
            );

            setMessage('Password reset successfully. Check your email for the new password.');
            setEmail(''); // Clear the email field
            onClose(); // Close the modal
        } catch (error) {
            console.error('Error in forgotPassword:', error);
            setMessage(error.message || 'Failed to reset password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Typography color="#B5A78A" fontFamily="GveretLevin" direction="rtl" textAlign="right" variant="h6" mb={2}>
                    שכחת סיסמה
                </Typography>
                <TextField
                    fullWidth
                    margin="normal"
                    label="כתובת מייל"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                {message && (
                    <Typography
                        variant="body2"
                        color={message.includes('successfully') ? 'green' : 'red'}
                        mt={2}
                    >
                        {message}
                    </Typography>
                )}
                <Button
                    variant="contained"
                    fullWidth
                    sx={{
                        backgroundColor: '#C4A484',
                        '&:hover': { backgroundColor: '#C4A484' },
                        mt: 2,
                    }}
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? 'שולח' : 'שלח'}
                </Button>
            </Box>
        </Modal >
    );
};

export default ForgotPassword;